const brandConfig = require("../../brand.config.js");

function hexToRgb(hex) {
  if (!/^#?([a-f\d]{3}|[a-f\d]{6})$/i.test(hex)) {
    return "0, 0, 0";
  }

  const normalized = hex.replace("#", "");
  const value = normalized.length === 3
    ? normalized.split("").map((part) => part + part).join("")
    : normalized;

  const number = parseInt(value, 16);
  return [
    (number >> 16) & 255,
    (number >> 8) & 255,
    number & 255,
  ].join(", ");
}

function resolveAssetUrl(url) {
  if (!url || /^(https?:)?\/\//.test(url) || url.startsWith("data:")) {
    return url;
  }

  const baseUrl = process.env.BASE_URL || "/";
  const normalizedBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const normalizedUrl = url.startsWith("/") ? url.substring(1) : url;

  return `${normalizedBase}${normalizedUrl}`;
}

function getSelectedBrandKey() {
  const selected = (process.env.VUE_APP_CLIENT_BRAND || brandConfig.defaultBrand).toLowerCase();
  return brandConfig.brands[selected] ? selected : brandConfig.defaultBrand;
}

const brandKey = getSelectedBrandKey();
const preset = brandConfig.brands[brandKey];

const brand = {
  key: brandKey,
  name: process.env.VUE_APP_BRAND_NAME || preset.name,
  primary: process.env.VUE_APP_BRAND_PRIMARY || preset.primary,
  dark: process.env.VUE_APP_BRAND_DARK || preset.dark,
  muted: process.env.VUE_APP_BRAND_MUTED || preset.muted,
  headerGradient: process.env.VUE_APP_BRAND_HEADER_GRADIENT || preset.headerGradient,
  pageBackground: process.env.VUE_APP_BRAND_PAGE_BACKGROUND || preset.pageBackground,
  logo: resolveAssetUrl(process.env.VUE_APP_BRAND_LOGO || preset.logo),
  logoClass: process.env.VUE_APP_BRAND_LOGO_CLASS || preset.logoClass,
  statusTextColor: process.env.VUE_APP_BRAND_STATUS_TEXT_COLOR || preset.statusTextColor,
};

export function applyBranding() {
  const root = document.documentElement;

  root.style.setProperty("--color-brandlight", brand.primary);
  root.style.setProperty("--color-branddark", brand.dark);
  root.style.setProperty("--color-brandblue", brand.muted);
  root.style.setProperty("--rgb-brandlight", hexToRgb(brand.primary));
  root.style.setProperty("--rgb-branddark", hexToRgb(brand.dark));
  root.style.setProperty("--rgb-brandblue", hexToRgb(brand.muted));
  root.style.setProperty("--brand-header-gradient", brand.headerGradient);
  root.style.setProperty("--brand-page-background", brand.pageBackground);
  root.style.setProperty("--brand-status-text-color", brand.statusTextColor);
}

export default brand;
